import React from "react";

import { TEmployeePosition } from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/model/types";

import PositionViewItem from "./PositionViewItem";

interface IPositionsViewSectionProps {
  employeeId: string;
  positions: TEmployeePosition[];
  refetch: () => void;
}

const EMPTY_MAIN_POSITION: TEmployeePosition = {
  number: "one",
  ActivePosition: null,
  InactivePositions: [],
};

const PositionsViewSection = ({
  employeeId,
  positions,
  refetch,
}: IPositionsViewSectionProps) => {
  const activePositions = positions.filter(
    (position) => position.ActivePosition,
  );
  const visiblePositions =
    activePositions.length || !positions.length
      ? activePositions
      : [EMPTY_MAIN_POSITION];

  return (
    <>
      {visiblePositions.map((position, index) => (
        <PositionViewItem
          key={`${position.number}-${index}`}
          position={position}
          employeeId={employeeId}
          refetch={refetch}
        />
      ))}
    </>
  );
};

export default PositionsViewSection;
